import { render, staticRenderFns } from "./AttributeByIdView.vue?vue&type=template&id=1852aef5"
import script from "./AttributeByIdView.vue?vue&type=script&lang=js"
export * from "./AttributeByIdView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports